import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import PCheck from "../../components/pos/PCheck";
import PDatePicker from "../../components/pos/PDatePicker";
import API from "../../utils/API";
import { StringUtils } from "../../utils/StringUtils";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
export default function ProductHistory(props) {
  const { t } = useTranslation();
  const translate = t;
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [inventory, setInventory] = useState(true);
  const [sale, setSale] = useState(true);
  const [price, setPrice] = useState(true);
  const [loading, setLoading] = useState(false);

  const options = {
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: false,
    isRowSelectable: false,
    serverSide: true,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: "400px",
    rowsPerPage: 16,
    rowsPerPageOptions: [16, 25, 50, 100],
    pagination: true,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
      }
    },
  };

  const [option, setOption] = useState(options);
  const [loadedOnce, setLoadedOnce] = useState(false);

  const [data, setData] = useState([]);

  const [reportUrl, setReportUrl] = useState("");
  useEffect(() => {
    let sdt = getDate({ defaultValue: "startOfMonth" });
    setStartDate(StringUtils.formatDate(sdt, 2));
    let edt = getDate({ defaultValue: "today" });
    setEndDate(StringUtils.formatDate(edt, 2));

    const opt = { ...options };

    let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
    search["inventory"] = true;
    search["sale"] = true;
    search["price"] = true;
    search["startDate"] = StringUtils.formatDate(sdt, 2);
    search["endDate"] = StringUtils.formatDate(edt, 2);

    opt.searchText = JSON.stringify(search);
    setOption(opt);

    loadDataFromServer(
      0,
      16,
      true,
      true,
      true,
      StringUtils.formatDate(sdt, 2),
      StringUtils.formatDate(edt, 2)
    );
  }, []);

  const onDownload = (url) => {
    const link = document.createElement("a");
    link.download = url;
    link.href = url;
    link.click();
  };

  /*useEffect(() => {
    if (loadedOnce) {
      const opt = { ...option };
      let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
      search["inventory"] = inventory;
      opt.searchText = JSON.stringify(search);
      //setOption(opt);
    }
  }, [inventory]);
  useEffect(() => {
    if (loadedOnce) {
      const opt = { ...option };
      console.log("Sale-opt", opt.searchText);
      let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
      search["sale"] = sale;
      opt.searchText = JSON.stringify(search);
      //setOption(opt);
    }
  }, [sale]);
  useEffect(() => {
    if (loadedOnce) {
      const opt = { ...option };
      let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
      search["price"] = price;
      opt.searchText = JSON.stringify(search);
      //setOption(opt);
    }
  }, [price]);

  useEffect(() => {
    if (loadedOnce) {
      const opt = { ...option };
      let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
      search["startDate"] = startDate;
      opt.searchText = JSON.stringify(search);
      //setOption(opt);
    }
  }, [startDate]);

  useEffect(() => {
    if (loadedOnce) {
      const opt = { ...option };
      let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
      search["endDate"] = endDate;
      opt.searchText = JSON.stringify(search);
      //setOption(opt);
    }
  }, [endDate]);*/

  function getDate(param) {
    //console.log(param);
    if (param.defaultValue) {
      if (param.defaultValue === "startOfMonth") {
        let dt = new Date();
        return new Date(dt.getFullYear(), dt.getMonth(), 1);
      } else if (param.defaultValue === "endOfMonth") {
        let dt = new Date();

        return new Date(
          dt.getFullYear(),
          dt.getMonth(),
          this.daysInMonth(dt.getMonth() + 1, dt.getFullYear())
        );
      } else if (param.defaultValue === "today") {
        return new Date();
      }
    } else {
      return new Date();
    }
  }

  const columns = [
    {
      name: "dateYMD",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "eventSource",
      label: translate("Activity Type"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "description",
      label: translate("Description"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "Quantity",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return <div style={{ textAlign: "right" }}>Quantity</div>;
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {tableMeta.tableData[tableMeta.rowIndex].stockChangeType}{" "}
              {tableMeta.tableData[tableMeta.rowIndex].changeQuantity}
            </div>
          );
        },
      },
    },
    {
      name: "stockQuantityAfter",
      label: translate("Stock"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return <div style={{ textAlign: "right" }}>Stock</div>;
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {tableMeta.tableData[tableMeta.rowIndex].stockQuantityAfter}
            </div>
          );
        },
      },
    },
    {
      name: "changeInPrice",
      label: translate("Stock"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return <div style={{ textAlign: "right" }}>Price Change</div>;
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {tableMeta.tableData[tableMeta.rowIndex].changeInPrice}
            </div>
          );
        },
      },
    },
    {
      name: "price",
      label: translate("Stock"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return <div style={{ textAlign: "right" }}>Price</div>;
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {tableMeta.tableData[tableMeta.rowIndex].price}
            </div>
          );
        },
      },
    },
    {
      name: "updatedBy",
      label: translate("Updated By"),
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  function onTableChange(tableState) {
    console.log(tableState);
    let searchJson = JSON.parse(tableState.searchText);
    console.log("###", searchJson);
    loadDataFromServer(
      tableState.page,
      tableState.rowsPerPage,
      searchJson.inventory,
      searchJson.sale,
      searchJson.price,
      searchJson.startDate,
      searchJson.endDate,
      tableState.sortOrder
    );
  }

  async function loadDataFromServer(
    page,
    pageSize,
    pInventory,
    pSale,
    pPrice,
    sdt,
    edt,
    sort,
    exportAs
  ) {
    setLoading(true);
    try {
      if (props.productBean) {
        if (exportAs) {
          let params = [
            {
              key: "startDate",
              value: sdt,
              label: "From",
              labelValue: sdt,
            },
            {
              key: "endDate",
              value: edt,
              label: "To",
              labelValue: edt,
            },
            {
              key: "productId",
              value: props.productBean.id,
              label: "Product",
              labelValue: props.productBean.name,
            },
          ];
          if (pInventory) {
            params.push({
              key: "inventory",
              value: pInventory,
              label: "Inventory",
              labelValue: "",
            });
          }
          if (pSale) {
            params.push({
              key: "sale",
              value: pSale,
              label: "Sale",
              labelValue: "",
            });
          }
          if (pPrice) {
            params.push({
              key: "price",
              value: pPrice,
              label: "Price",
              labelValue: "",
            });
          }

          const { data } = await API.post("/report/generate", {
            template: "reports/generic/product_history",
            outFormat: exportAs,
            paramList: params,
            pluginMode: "v2",
          });
          onDownload("/report/download/" + data.fileName);
        } else {
          const { data } = await API.post("/report/analytics", {
            template: "reports/analytics/product_history",
            productId: props.productBean.id,
            startDate: sdt,
            endDate: edt,
            inventory: pInventory,
            sale: pSale,
            price: pPrice,
            page: page,
            pageSize: pageSize,
            sort: { name: "dateYMD", direction: "desc" },
            exportAs: exportAs,
          });
          setData(data.data);
          const opt = { ...option };
          let search = JSON.parse(opt.searchText ? opt.searchText : "{}");
          search["inventory"] = pInventory;
          search["sale"] = pSale;
          search["price"] = pPrice;
          search["startDate"] = sdt;
          search["endDate"] = edt;

          opt.searchText = JSON.stringify(search);
          opt.page = page;
          opt.count = parseInt(data.metadata[0].total);
          setOption(opt);
          setLoadedOnce(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }

  return (
    <Grid container sx={{ padding: "10px" }}>
      <Grid item xs={2}>
        <Grid container>
          <Grid item xs={12} sx={{ marginTop: "5px" }}>
            <PCheck
              onChange={(value) => setInventory(value)}
              checked={inventory}
              label={translate("Inventory")}
            ></PCheck>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "5px" }}>
            <PCheck
              onChange={(value) => setSale(value)}
              checked={sale}
              label={translate("Sale")}
            ></PCheck>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: "5px" }}>
            <PCheck
              onChange={(value) => setPrice(value)}
              checked={price}
              label={translate("Price")}
            ></PCheck>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: "5px", paddingRight: "10px" }}>
            Start Date
          </Grid>
          <Grid item xs={12}>
            <PDatePicker
              value={startDate}
              onChange={(value) => {
                console.log(value);
                setStartDate(StringUtils.formatDate(value.$d, 2));
              }}
            ></PDatePicker>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "5px", paddingRight: "10px" }}>
            End Date
          </Grid>
          <Grid item xs={12}>
            <PDatePicker
              value={endDate}
              onChange={(value) => {
                console.log(value);
                setEndDate(StringUtils.formatDate(value.$d, 2));
              }}
            ></PDatePicker>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "5px" }}>
            <Button
              variant="contained"
              fullWidth
              disabled={loading}
              onClick={() => {
                loadDataFromServer(
                  0,
                  16,
                  inventory,
                  sale,
                  price,
                  startDate,
                  endDate,
                  { name: "dateYMD", direction: "desc" }
                );
              }}
            >
              {loading && <CircularProgress size={20} />}
              Load
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={10} sx={{ paddingLeft: "10px" }}>
        <Grid container>
          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Tooltip title={translate("Export as Excel")}>
              <IconButton
                size="small"
                color="primary"
                disabled={loading}
                onClick={() => {
                  loadDataFromServer(
                    0,
                    16,
                    inventory,
                    sale,
                    price,
                    startDate,
                    endDate,
                    { name: "dateYMD", direction: "desc" },
                    "excel"
                  );
                }}
              >
                <ArticleIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={translate("Export as pdf")}>
              <IconButton
                size="small"
                color="primary"
                disabled={loading}
                onClick={(event) => {
                  loadDataFromServer(
                    0,
                    16,
                    inventory,
                    sale,
                    price,
                    startDate,
                    endDate,
                    { name: "dateYMD", direction: "desc" },
                    "pdf"
                  );
                }}
              >
                <PictureAsPdfIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <MUIDataTable data={data} columns={columns} options={option} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: "5px" }}></Grid>
    </Grid>
  );
}
